import { formatRelative } from "date-fns";
import { enAU } from "date-fns/locale";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ActivityIndicator from "../components/ActivityIndicator";
import { Layout } from "../components/Layout";
import StatusIcon from "../components/StatusIcon";
import { Notification } from "../models/notification";
import { UserInfo } from "../models/user-info";
import notificationService from "../services/notification-service";

type EditListScreenProps = {
  userInfo: UserInfo;
};

const EditListScreen: React.FC<EditListScreenProps> = (props) => {
  const [notifications, setNotifications] = useState<Notification[]>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    notificationService
      .getUserNotifications()
      .then((res) => {
        setNotifications(res?.items);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  }, []);

  const titleFormatted = (title: string, body: string) => {
    return (title + " " + body).substring(0, 20);
  };

  return (
    <Layout userInfo={props.userInfo} loading={loading}>
      <div className="pt-8 px-20">
        <div className="grid grid-cols-5 border-b">
          <p className="">Notification title</p>
          <p className="">Authorised by</p>
          <p className="">Status</p>
          <p className="">Send date</p>
          <p className="">Edit/View</p>
        </div>
        {notifications ? (
          <>
            {notifications.length > 0 ? (
              notifications.map((n) => (
                <div className="grid grid-cols-5 my-6" key={n.uuid}>
                  <p>{titleFormatted(n.Title, n.Body)}</p>
                  <p>{n.ApproverName || "Not yet authorised"}</p>
                  <StatusIcon status={n.Status} />
                  <p className="capitalize">
                    {formatRelative(new Date(n.SendAt), new Date(), {
                      locale: enAU,
                    })}
                  </p>
                  <p>
                    <Link
                      to={`/edit/${n.uuid}`}
                      className={`${
                        n.Status === "pending" ? "bg-blue-800" : "bg-slate-700"
                      } text-white text-xs rounded px-5 py-2`}
                    >
                      {n.Status === "pending" ? "Edit" : "View"}
                    </Link>
                  </p>
                </div>
              ))
            ) : (
              <p>No records.</p>
            )}
          </>
        ) : (
          <ActivityIndicator />
        )}
      </div>
    </Layout>
  );
};

export default EditListScreen;
